import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import ViewLabClientComp from './ViewLabClientComp';

function ViewLabClient() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <ViewLabClientComp />
      </div>
    </div>
  );
}

export default ViewLabClient;
